export function initPinchZoom(zoomable) {
  let scale = 1;
  let startDist = 0;
  let initialScale = 1;
  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let lastX = 0;
  let lastY = 0;
  let lastTap = 0;

  const container = zoomable.parentElement;

  const getDistance = (touches) => {
    const [a, b] = touches;
    return Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
  };

  const getMidpoint = (touches) => {
    const [a, b] = touches;
    return {
      x: (a.clientX + b.clientX) / 2,
      y: (a.clientY + b.clientY) / 2,
    };
  };

  const resetZoom = () => {
    scale = 1;
    lastX = 0;
    lastY = 0;
    zoomable.style.transform = 'scale(1)';
  };

  container.addEventListener('touchstart', (e) => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTap;

    if (e.touches.length === 1 && tapLength < 300 && tapLength > 0) {
      e.preventDefault();
      resetZoom();
      lastTap = 0; // reset to prevent triple tap
      return;
    } else {
      lastTap = currentTime;
    }

    if (scale > 1) {
      e.stopPropagation(); // prevent slider swipe
    }

    if (e.touches.length === 2) {
      e.preventDefault();
      startDist = getDistance(e.touches);
      initialScale = scale;

      const midpoint = getMidpoint(e.touches);
      const containerRect = container.getBoundingClientRect();
      const originX = midpoint.x - containerRect.left;
      const originY = midpoint.y - containerRect.top;

      zoomable.style.transformOrigin = `${originX}px ${originY}px`;
    } else if (e.touches.length === 1 && scale > 1) {
      isDragging = true;
      startX = e.touches[0].clientX - lastX;
      startY = e.touches[0].clientY - lastY;
    }
  });

  container.addEventListener('touchmove', (e) => {
    if (e.touches.length === 2) {
      e.preventDefault();
      const dist = getDistance(e.touches);
      scale = Math.min(Math.max(initialScale * (dist / startDist), 1), 3);
      zoomable.style.transform = `scale(${scale}) translate(${lastX / scale}px, ${lastY / scale}px)`;
    } else if (e.touches.length === 1 && isDragging) {
      e.preventDefault();
      const containerRect = container.getBoundingClientRect();
      const zoomedWidth = zoomable.offsetWidth * scale;
      const zoomedHeight = zoomable.offsetHeight * scale;

      const currentX = e.touches[0].clientX - startX;
      const currentY = e.touches[0].clientY - startY;

      const maxX = Math.max(0, (zoomedWidth - containerRect.width) / 2);
      const maxY = Math.max(0, (zoomedHeight - containerRect.height) / 2);

      lastX = Math.max(-maxX, Math.min(currentX, maxX));
      lastY = Math.max(-maxY, Math.min(currentY, maxY));

      zoomable.style.transform = `scale(${scale}) translate(${lastX / scale}px, ${lastY / scale}px)`;
    }
  });

  container.addEventListener('touchend', () => {
    if (scale <= 1.05) {
      resetZoom();
    }
    isDragging = false;
  });
}

export function initPinchZoomOnLoad() {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.imageCarousel__modal_wrapper .zoomable').forEach(initPinchZoom);
  });
}
